import { PlatformPermissions } from '@/constants/platformPermissions';
import { useAuth } from '@/context/auth';

export const useHasTeamsPermissions = (requiredPermissions: PlatformPermissions[]) => {
  const { userTeamsPermissions } = useAuth();

  // No permissions means custom roles, so we treat it as read permissions
  if (
    userTeamsPermissions.length === 0 &&
    requiredPermissions.every((permission) => PlatformPermissions.GENERAL_READ === permission)
  ) {
    return true;
  }

  return requiredPermissions.every((permission) => userTeamsPermissions.includes(permission));
};
